import { z } from 'zod';

/** Reservation modes supported by Premium for shopping. */
const PremiumReservationMode = ['delivery', 'pickup'] as const;
export const PremiumReservationModeSchema = z.enum(PremiumReservationMode);

export type PremiumReservationMode = (typeof PremiumReservationMode)[number];
